export function getSortAttributeValue (currentKey: string, sortByKey: string, sortDesc: boolean) {
  if (currentKey === sortByKey) {
    return sortDesc ? "descending" : "ascending";
  }

  return "none";
}
